
import { locale } from './modules/globals.js';

import heroSlider from './modules/hero-slider';
import forms from './modules/form-handler';
import searchBox from './modules/search-box';
import tabBar from './modules/tab-bar';
import boxSlider from './modules/box-slider';
import imageCarousel from './modules/image-carousel';
import smThumbs from './modules/social-media-thumbs';
import videoHandler from './modules/video-handler';
import smoothAnchors from './modules/smooth-anchors';
import eventPopup from './modules/event-popup';
import toolbox from './modules/toolbox';
import eventBrowser from './modules/event-browser';
import eventLoader from './modules/events-loader';
import listFilter from './modules/list-filter';

heroSlider();
searchBox();
tabBar();
forms();
boxSlider();
imageCarousel();
smThumbs();
videoHandler();
smoothAnchors();
eventBrowser();
eventLoader();
eventPopup();
listFilter();
toolbox;

$('[data-nav-trigger]').on('click', () => {
  $('html').toggleClass('show-nav');
})

$('.addthis-toggle').on('click', function() {
  $(this).toggleClass('show-tools');
})


$('[data-fancybox]').fancybox();

try {
  if (moment) {
    if (locale.dir == "ltr") {
      moment.locale('en-gb');
    } else {
      moment.locale('ar-ae');
    }
  }
} catch {

}

